<template>
  <div class="chatter-status-wrap">
    <div class="chatter-status-header">
      <div class="custom-select-box dropdown project" data-field="project">
        <div class="select">
          <span class="text">{{ selectedProjectName }}</span>
        </div>
      </div>
      <div class="custom-select-box dropdown assignee" style="margin-left:1em;">
        <div class="select">
          <span class="text">{{ selectedAssigneeName }}</span>

        </div>
      </div>
        <div class="col" style="display: flex; justify-content: flex-end;">
          <b-modal ref="export" id="export" :hide-header="false" :hide-footer="true" size="lg" title="Export"
            modal-class="popup-export">
            <b-form-row>
                <!-- <label for="field">Project</label>
                <b-form-select id="project-list" size="sm" class="mr-4" v-model="wbsProject">
                  <template v-for="option in options.projectOptions">
                    <option v-if="option.value !== ''" :value="option.value" :key="option.value">{{ option.text }}
                    </option>
                  </template>
                </b-form-select> -->
                <project-filter :selectedProjectId="wbsProject" @changeProject="(selectedProject) => wbsProject = selectedProject" :customStyle="{display:'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}"/>
            </b-form-row>
            <div class="btn-wrap">
              <b-button class="btn-primary small" block @click="extractWBS(wbsProject)"
                :disabled="wbsProject == null || wbsProject === ''">Download
              </b-button>
              <b-button class="btn-secondary small" @click="$bvModal.hide('export')">Cancel
              </b-button>
            </div>
          </b-modal>
            <div class="btn-group-area align-items-center">
                <!-- Excel Button
                <b-button variant="outline-secondary" @click="pushRoute('/chatter/import')" class="btn btn-export">Excel
                </b-button>
                -->
                <!-- <b-button v-b-modal.export variant="outline-secondary" class="btn btn-export">Export
                </b-button> -->
            </div>
        <div class="row align-items-center">
            <button type="button"
                class="recent-button"
                @click="retrieveRecentChatterList"
                v-if="!occupied">
                <span class="text">Recent</span>
                <span class="icon">
                  <img :src="require('@/assets/images/recent.svg')">
                </span>
            </button>
            <!-- Refresh Button(검색조건 있을때만 보이게)-->
            <button type="button"
                class="refresh-button"
                 @click="refreshChatterList"
                v-if="searchOptionsLabel"> 
                <!-- Search Options Label-->
                 <span class="text">{{ searchOptionsLabel }}</span>
                <span class="icon"></span>
            </button>
        </div>
      </div>
    </div>
    <div class="status-box-wrap">
      <div class="status-box">
        <div class="status-title">
          To Do
          <ChatterTooltip style="width: 20px; margin-left: 0.5rem">
            <template #header>
              <span>To Do - Sub Status</span>
            </template>
            <template #content>
              <p>
                <div class="p-0" style="width:330px;">
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Overdue</span>
                    <span style="padding-left: 0.4em">Due Date가 오늘을 지난 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Today</span>
                    <span style="padding-left: 0.4em">Start Date가 오늘인 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Scheduled</span>
                    <span style="padding-left: 0.4em">Start Date가 아직 오지 않은 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">TBD</span>
                    <span style="padding-left: 0.4em">Due Date, Start Date가 없는 MeMO</span>
                  </div>
                </div>
              </p>
            </template>
          </ChatterTooltip>
        </div>
        <div class="status-detail-list">
          <button type="button"
                  class="status-detail overdue"
                  @click="onStatusSelected('TO_DO', 'OVERDUE')">
            <span class="status-text">Overdue</span>
            <span class="num">{{ Status.toDo.overdue }}</span>
          </button>
          <button type="button"
                  class="status-detail today"
                  @click="onStatusSelected('TO_DO', 'TODAY')">
            <span class="status-text">Today</span>
            <span class="num">{{ Status.toDo.today }}</span>
          </button>
          <button type="button"
                  class="status-detail scheduled"
                  @click="onStatusSelected('TO_DO', 'SCHEDULED')">
            <span class="status-text">Scheduled</span>
            <span class="num">{{ Status.toDo.scheduled }}</span>
          </button>
          <button type="button"
                  class="status-detail scheduled not-scheduled"
                  @click="onStatusSelected('TO_DO', 'TBD')">
            <span class="status-text">TBD</span>
            <span class="num">{{ Status.toDo.tbd }}</span>
          </button>
        </div>
      </div>
      <div class="status-box">
        <div class="status-title">
          In Progress
          <ChatterTooltip style="width: 20px; margin-left: 0.5rem">
            <template #header>
              <span>In Progress - Sub Status</span>
            </template>
            <template #content>
              <p>
                <div class="p-0" style="width:330px;">
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Overdue</span>
                    <span style="padding-left: 0.4em">Due Date가 오늘을 지난 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Today</span>
                    <span style="padding-left: 0.4em">Due Date가 오늘인 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">Scheduled</span>
                    <span style="padding-left: 0.4em">Due Date가 아직 오지 않은 MeMO</span>
                  </div>
                  <div style="display: flex; padding: 0;">
                    <span style="width: 25%; border-right: 1px grey solid; text-align: center;">TBD</span>
                    <span style="padding-left: 0.4em">Due Date, Start Date가 없는 MeMO</span>
                  </div>
                </div>
              </p>
            </template>
          </ChatterTooltip>
        </div>
        <div class="status-detail-list in-progress">
          <button type="button"
                  class="status-detail overdue"
                  @click="onStatusSelected('IN_PROGRESS', 'OVERDUE')">
            <span class="status-text">Overdue</span>
            <span class="num">{{ Status.inProgress.overdue }}</span>
          </button>
          <button type="button"
                  class="status-detail today"
                  @click="onStatusSelected('IN_PROGRESS', 'TODAY')">
            <span class="status-text">Today</span>
            <span class="num">{{ Status.inProgress.today }}</span>
          </button>
          <button type="button"
                  class="status-detail scheduled"
                  @click="onStatusSelected('IN_PROGRESS', 'SCHEDULED')">
            <span class="status-text">Scheduled</span>
            <span class="num">{{ Status.inProgress.scheduled }}</span>
          </button>
          <button type="button"
                  class="status-detail scheduled not-scheduled"
                  @click="onStatusSelected('IN_PROGRESS', 'TBD')">
            <span class="status-text">TBD</span>
            <span class="num">{{ Status.inProgress.tbd }}</span>
          </button>
        </div>
      </div>
      <div class="status-box">
        <div class="status-title">Completed</div>
        <div class="status-detail-list">
          <button type="button"
                  class="status-detail black done"
                  @click="onStatusSelected('DONE', '')">
            <span class="status-text">Done</span>
            <span class="num">{{ Status.completed.done }}</span>
          </button>
          <button type="button"
                  class="status-detail black cancelled"
                  @click="onStatusSelected('CANCELLED', '')">
            <span class="status-text">Cancelled</span>
            <span class="num">{{ Status.completed.cancelled }}</span>
          </button>
          <button type="button"
                  class="status-detail black closed"
                  @click="onStatusSelected('CLOSED', '')">
            <span class="status-text">Closed</span>
            <span class="num">{{ Status.completed.closed }}</span>
          </button>
          <!-- 24-03-07 yhkim@hiaas.co.kr confirmed 숨김 처리 -->
          <!-- <button type="button"
                  class="status-detail black confirmed"
                  @click="onStatusSelected('Completed', 'Confirmed',chatStatus.completed.confirmed)">
            <span class="status-text">Confirmed</span>
            <span class="num">{{ chatStatus.completed.confirmed.length }}</span>
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectFilter from '../wbs/ProjectFilter.vue';
import ChatterTooltip from './ChatterTooltip.vue';

export default {
  props:['isRefreshed', 'projectId', 'assignee'],
  components: {
    ProjectFilter,
    ChatterTooltip
  },
  async created() {
    this.getChatterSummary();

    /* searchOptionsLabel(검색조건) 생성 로직: 검색 조건 걸고-> Detail 조회-> Close 후에도 라벨이 남아있기 위함*/
    // StatusBar 또는 Filter Label 만드는 함수 호출
    // if (this.occupied) {
    //   //notification을 조회하는 상황에서는 searchOptionsLabel이 이미 설정되어있음
    //   if (this.searchOptionsLabel === '') {
    //     this.getStatusBarSearchOptionsLabel();
    //   }
    // }
    // if (this.filterOccupied) {
    //   this.getFilterSearchOptionsLabel();
    // }
    // /* searchOptionsLabel(검색조건) 생성 로직 */
    // if (!this.chats.length > 0) {
    //   this.retrieveChatterList();
    // }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
  computed: {
    chats() {
      var chats = this.$store.getters['chatter/chats'];
      //status bar 활성화된 경우(pageLimit 만큼 chat load)
      if (this.occupied) {
        return chats.slice(0, this.pageLimit * this.filter.page);
      }
      return chats;
    },
    occupied() {
      return this.$store.getters['chatter/occupied'];
    },
    // Vuex에서 가용한 프로젝트 선택옵션 목록 조회
    projectOptions() {
      return this.$store.getters['chatter/projectOptions'];
    },
    // Vuex에서 가용한 Assignee 선택옵션 목록 조회
    // 이미 선택한 프로젝트에 따라 가용한 Assignee 목록변경
    assigneeOptions() {
      return this.$store.getters['chatter/assigneeOptions'];
    },
    statusDashboardFilter(){
      return this.$store.getters['chatter/statusDashboardFilter'];
    },
    searchOptionsLabel() {
      const label = this.$store.getters['chatter/searchOptionsLabel'];

      //All Projects > All Status > All Assignees 계층 문구는 안되게 하기
      if(label === 'Recent') return label;
      else if(label === 'My Notifications') return label;

    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userId() {
      return this.currentUser.caller;
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    selectedProjectName() {
      const selectedProjectId = this.filter.projectId;
      
      if(selectedProjectId == '') return 'All Projects'

      const project = this.projectOptions.find(project => project.projectId === selectedProjectId);
      if (project) {
        return project.name;
      }
    },
    selectedAssigneeName() {
      const selectedAssigneeId = this.filter.assignee;
      // const userName = this.currentUser.userkorname + "(" + this.currentUser.caller + ")";

      if(selectedAssigneeId == '') return 'All Assignees';

      const assignee = this.assigneeOptions.find(assignee => assignee.value === selectedAssigneeId);
      if (assignee) {
        return assignee.text;
      }
    }
  },
  data() {
    return {
      wbsProject: '',
      allChats:[],
      showDropdown: '',
      Status: {
        toDo: {
          overdue: 0,
          scheduled: 0,
          tbd: 0,
          today: 0
        },
        inProgress: {
          overdue: 0,
          scheduled: 0,
          tbd: 0,
          today: 0
        },
        completed: {
          done: 0,
          cancelled: 0,
          closed: 0,
          confirmed: 0
        }
      },
      isStatusBarClicked:false,
      pageLimit: 10,
    }
  },
  watch: {
    isRefreshed(){
      //this.$store.commit('chatter/resetStatusBar');
      //status bar occupied 취소
      this.$store.commit('chatter/setOccupied', false);
      // filter 정보 초기화
      this.$store.commit('chatter/resetStatusDashboardFilter');
    },
    projectId() {
      this.getChatterSummary();
    },
    assignee() {
      this.getChatterSummary();
    }
  },
  methods: {
    async getChatterSummary() {
      try {
      // API 요청 파라미터
      const params = {
        pageSize: 0,
        // updated: 'Y', 2023-08-29 사용하지 않음
        projectId: this.filter.projectId,
        assignee: this.filter.assignee,
        withClosedProjects: this.filter.withClosedProjects
      }
      

      // const filterCondition = (chat) => 
      //     (this.project.projectId != null || chat.projectId == this.project.projectId) &&
      //     (this.assignee.userId != null || chat.assignee == this.assignee.userId);

        // 인증 토큰 가져오기
        const authToken = accessToken();
        
         // 요청 헤더에 Authorization 토큰 추가
        const headers = { Authorization: authToken };
     
        let response = await axios.get('/chatter/getSummary', { params, headers} );

        this.allChats = response.data.list;        

        const responseData = response.data;

        this.Status = responseData;

      } catch (error) {
        await this.showError(error);
      }
    },
    async retrieveChatterList() {
      // If Chatter Status Table has already occupied the list, return
      // For details, refer to Chatter Vuex (chatter.module.js)
      if (this.occupied) {
        this.getStatusBarSearchOptionsLabel();
        return;
      }
      try {
        this.loading = true;
        if (this.filterOccupied) {
          this.getFilterSearchOptionsLabel();
        }

        // Fetch chats
        let response = await axios.post('/chatter/retrieveChatterList',
          this.filter,
          { headers: { Authorization: accessToken() } }
        );

        const status = response.data.status;

        if(status === "200") {
          const body = response.data.body;
          // Commit the newly fetched chatters to Vuex
          if (Array.isArray(body.list)) {
            body.list.forEach(item => item.isExpanded = false);
            this.$store.commit('chatter/setChats', body.list);
            // Set the total number of chatters in Vuex
            this.$store.commit('chatter/setTotal', body.total);
            //refresh 값 초기화(자식(=ChatterFilter.vue)에게 보내고 나면 초기화)=> Search Detail 창 닫힘, 작성중인 query 초기화
            // this.refresh = false;
          }
        } else {
          this.$bvToast.toast(response.data.message, 
          {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 500,
            variant: "danger"
          });
        }
        
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    // //searchOptionsLabel 생성
    // /** 24-02-23 yhkim@hiaas.co.kr
    //  *  label 생성 로직 변경
    //  * @param {project, status, assignee} options 
    //  */
    //  getSearchOptionsLabel(status, subStatus) {
    //   // const keys = Object.keys(options);
      
 
    //   if(this.isEmpty(status)) {
    //     status = "All Status"
    //   }
      
    //   if(!this.isEmpty(subStatus)) {
    //     status += " > " + subStatus;
    //   }


    //   return `${status}`;
      

    //   // for(let i = 0; i < keys.length; i++) {
    //   //   let label = '';
    //   //   const key = keys[i];
    //   //   const option = options[key];
        
    //   //   if(this.isEmpty(option)) {
    //   //     switch (key) {
    //   //       case "project":
    //   //         label = "All Projects";
    //   //         break;
    //   //       case "status":
    //   //         label = "All Status";
    //   //         break;
    //   //       case "assignee":
    //   //         label = "All Assignee";
    //   //         break;
    //   //       default:
    //   //         label = "Unknown Option";
    //   //         break;
    //   //     }
    //   //   } else {
    //   //     label = option;
    //   //   }
    //   //   searchOptionsLabel += label;
    //   //   if( i != keys.length - 1) {
    //   //     searchOptionsLabel += ' > ';
    //   //   }
    //   // }

    //   return searchOptionsLabel;
    // },
    refreshChatterList() {
      this.$store.commit('chatter/setOccupied', false);
      this.$store.commit('chatter/setFilterOccupied', false)
      this.$store.commit('chatter/resetChats');
      this.$store.commit('chatter/setTotal', 0);
      this.$store.commit('chatter/resetFilter');
      this.$store.commit('chatter/chatterListRefresh');
      // this.refresh = true;
      //search Detail 창 닫기
      this.$store.commit('chatter/setToggleFilterSearchDetail', false);
      //검색 조건 내용 초기화
      this.$store.commit('chatter/setSearchOptionsLabel', '');
      this.retrieveChatterList();
      //statusbar 정보 초기화
      this.$store.commit('chatter/resetStatusDashboardFilter');
    },
    reloadChatterList() {
      this.$store.commit('chatter/resetChats');
      this.$store.commit('chatter/setTotal', 0);
      this.$store.commit('chatter/setPage', 1);
      this.retrieveChatterList();
    },
    setChats() {
      // 필터에 선택된 status별 chat 등록
      let chats = this.allChats;

      this.$store.commit('chatter/setPage', 1);
      this.$store.commit('chatter/setChats', chats);
      this.$store.commit('chatter/setTotal',chats.length); 
    },
    onStatusSelected(status, subStatus) {
      // Chatter 메인 필터 비활성화
      this.$store.commit('chatter/setFilterOccupied',true);

      // Chatter 메인 필터 초기화
      // this.$store.commit('chatter/resetFilter');

      this.$store.commit('chatter/resetChats');
      //status bar 활성화
      this.$store.commit('chatter/setOccupied', false);
      // 현재 status 저장
      // Main Status (To do, In Progress...)
      this.$store.commit('chatter/setStatusDashboardFilterStatus', status);
      // Sub Status (Overdue, TBD...) 
      this.$store.commit('chatter/setStatusDashboardFilterSubStatus', subStatus);

      // status, subStaus에 맞는 Chat을 테이블에 출력
      // this.$store.commit('chatter/resetChats');
      // this.$store.commit('chatter/setChats', chats);
      // this.$store.commit('chatter/setTotal', chats.length);
      
      //status bar clicked 여부 전송
      this.$emit("click:subStatusBadge", {status: status, subStatus : subStatus});

      //subStatus 가 없으면 status 로 세팅 있으면 subStatus 로 세팅해서 setSearchOptionsLabel가 실행
      if(!subStatus){
        this.$store.commit('chatter/setSearchOptionsLabel', status);
      }else{
        this.$store.commit('chatter/setSearchOptionsLabel', subStatus);
      }
    },
    async extractWBS(projectID) {

      try {
        // this.loading = true;
        const response = await axios.get(`chatter/export/wbs/${projectID}`, {
          responseType: 'blob',
          headers: {
            Authorization: accessToken(),
          },
        });
        const fileName = this.wbsProject + '_WBS.xlsx';

        if (response.status === 200) {
          const url = URL.createObjectURL(response.data)

          const link = document.createElement('a');
          if (url) {
            link.href = url;
            link.download = fileName;
            link.click();
          }
        }
        // this.downloadBlob(base64Data, fileName);
      } catch (error) {
        if (error.status != 401) {
          if (error.response) {
            this.msgStatus = error.response.status;
          }
          this.blobToString(error.response.data).then((result) => {
            this.msgContent = (JSON.parse(result).message);
          });
          this.$bvModal.show('wordCloudMessageModal');
        }
      } finally {
        this.loading = false;
        this.$refs['export'].hide();
      }
    },
    downloadBlob(blob, fileName) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE 및 Microsoft Edge 브라우저에서 다운로드
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // 다른 모든 브라우저에서 다운로드
        const link = document.createElement('a');
        const url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + blob;
        link.href = url;
        link.download = fileName;
        link.click();
      }
    },
    retrieveRecentChatterList() {
      try {
        

        // 24-04-19 해당 로직 백엔드로 옮김
        // 최근에 본 ChatId 목록 조회
        // axios.get("/chatter/retrieveUserChatterHistory", {
        //   params: {
        //     userId: this.userId
        //   },
        //   headers: {
        //     Authorization: accessToken()
        //   }
        // }).then(response => {

        //   let recentChatIdList = response.data;
        //   // vuex query 에 조회한 chatId만 조회하는 query 설정
        //   // 쿼리 생성
        //   let chatIdListParams = "";
        //   if (recentChatIdList.length > 0) {
        //     for (let i = 0; i < recentChatIdList.length; i++) {
        //       chatIdListParams += "'" + recentChatIdList[i] + "'"
        //       if (i != recentChatIdList.length - 1) {
        //         chatIdListParams += ","
        //       }
        //     }
        //   } else {
        //     chatIdListParams = "''";
        //   }

        //   let sql = `chat_id IN (${chatIdListParams}) ORDER BY FIELD(CHAT_ID, ${chatIdListParams})`;

        //   // 조회 필터 조건들 초기화
          this.$store.commit('chatter/setFilterOccupied', false);
          this.$store.commit('chatter/setRetrieveType', "RECENT");
          this.filter.hierarchy = false;
          
        //   this.$store.commit('chatter/resetFilter');
        //   this.$store.commit('chatter/setQuery', sql);

          // reloadChatterList 호출
          this.reloadChatterList();
          //recent 클릭 -> MeMO 조회 -> close 후에도 filter 비활성화 하기 위함
          this.$store.commit('chatter/setOccupied', true);
          this.$store.commit('chatter/setSearchOptionsLabel', 'Recent');

        // })
        // vuex query 삭제
      } catch (error) {
        this.showError(error);
      }
    }
  }
}
</script>

<style scoped>
.chatter-status-wrap {
    padding-top: 1.333rem;
    padding-left: 0.666rem;
    padding-right: 0.666rem;
    padding-bottom: 0.666rem;
    margin-bottom: 2rem;
    border-radius: 30px;
    background: linear-gradient(172deg, #2E2E38 0%, #40404B 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    font-family: 'NanumGothic';
}

.chatter-status-wrap .status-box-wrap {
    display: flex;
    padding: 1.066rem 0rem;
    border-radius: 22px;
    background: rgba(0, 0, 0, 0.30);
}

.chatter-status-wrap .status-box {
    position: relative;
    width: 33.333%;
    padding: 0 0.333rem;
}

.chatter-status-wrap .status-box:not(:last-child)::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  border-radius: 3px;
  background-color: #747480;
}

.chatter-status-wrap .status-box .status-title {
    padding-left: 0.4rem;
    color: #FFF;
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
}

.chatter-status-wrap .status-box .status-detail-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, auto));
    gap: 0.266rem;
    margin-top: 0.933rem;
}

.chatter-status-wrap .status-box .status-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.533rem 0.666rem 0.533rem 0.8rem;
    border-radius: 34px;
    border: none;
}

.chatter-status-wrap .status-box .status-detail.overdue {
    background-color: #FFDCDC;
}

.chatter-status-wrap .status-box .status-detail.overdue:hover {
    background-color: #FFC0C0;
}

.chatter-status-wrap .status-box .status-detail.scheduled {
    background-color: #C6EAC0;
}

.chatter-status-wrap .status-box .status-detail.scheduled:hover {
    background-color: #B3EAAA;
}

.chatter-status-wrap .status-box .status-detail.not-scheduled {
    background-color: #E7E7EE;
}

.chatter-status-wrap .status-box .status-detail.not-scheduled:hover {
    background-color: #C4C4CD;
}

.chatter-status-wrap .status-box .status-detail-list.in-progress .status-detail.not-scheduled {
    background-color: #FFDCDC;
}

.chatter-status-wrap .status-box .status-detail-list.in-progress .status-detail.not-scheduled:hover {
    background-color: #FFC0C0;
}

.chatter-status-wrap .status-box .status-detail.today {
    background-color: #FFF1BF;
}

.chatter-status-wrap .status-box .status-detail.today:hover {
    background-color: #FFE897;
}

.chatter-status-wrap .status-box .status-detail.black {
    background-color: #1B1B1B;
    border: 1px solid #1B1B1B;
}

.chatter-status-wrap .status-box .status-detail.black:hover {
    border: 1px solid #747480;
}

.chatter-status-wrap .status-box .status-detail .num {
    flex-shrink: 0;
    display: inline-block;
    min-width: 22px;
    padding: 0.133rem 6px;
    border-radius: 30px;
    background-color: #FFF;
    color: #2E2E38;
    font-size: 11px;
    font-weight: 700;
    line-height: 150%;
}

.chatter-status-wrap .status-box .status-detail.black .num {
    background-color: #2E2E38;
    color: #FFF;
}

.chatter-status-wrap .status-box .status-detail .status-text {
    color: #2E2E38;
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: left;
}

.chatter-status-wrap .status-box .status-detail.done .status-text {
    color: #CFDDFF;
}

.chatter-status-wrap .status-box .status-detail.cancelled .status-text {
    color: #E4E4EA;
}

.chatter-status-wrap .status-box .status-detail.closed .status-text {
    color: #D7F5D6;
}

.chatter-status-wrap .status-box .status-detail.confirmed .status-text {
    color: #FFB88F;
}

.chatter-status-wrap .status-box .status-detail.gray {
    background-color: #E7E7EE;
}

.chatter-status-wrap .status-box .status-detail.gray:hover {
    background-color: #C4C4CD;
}

.chatter-status-wrap .status-box .status-detail.gray .num {
    background-color: #2E2E38;
    color: #FFF;
}

.chatter-status-wrap .status-box .status-detail.done.gray .status-text {
    color: #1755CC;
}

.chatter-status-wrap .status-box .status-detail.cancelled.gray .status-text {
    color: #9696A0;
}

.chatter-status-wrap .status-box .status-detail.closed.gray .status-text {
    color: #168D4C;
}

.chatter-status-wrap .status-box .status-detail.confirmed.gray .status-text {
    color: #2E2E38;
}

.chatter-status-wrap .chatter-status-header {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-bottom: 1.333rem;
    padding: 0 1rem;
}

.chatter-status-wrap .custom-select-box {
    position: relative;
    text-align: left;
    /* cursor: pointer; */
    font-family: 'NanumGothic';
    width: 23%;
}
.chatter-status-wrap .custom-select-box.assignee {
  width: 25%;
}

.chatter-status-wrap .custom-select-box .select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0 0.933rem;
    width: 100%;
    height: 45px;
}

.chatter-status-wrap .custom-select-box .select .text {
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 30px;
    font-weight: 700;
    line-height: 150%;
}
.chatter-status-wrap .custom-select-box.assignee .select .text {
  font-size: 18px;
}

.chatter-status-wrap .custom-select-box .select .project-id {
    color: rgba(255, 255, 255, 0.40);
    font-family: 'NanumGothic';
    font-size: 30px;
    font-weight: 400;
    line-height: 150%;
}

.chatter-status-wrap .custom-select-box .select .icon-arrow {
    display: block;
    width: 30px;
    height: 30px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><path d="M24.002 11.5003L15.252 20.2503L6.50195 11.5003" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.chatter-status-wrap .opt-list {
    display: none;
    position: absolute;
    top: 4.333rem;
    left: 0;
    z-index: 150;
    width: 340px;
    max-height: 320px;
    padding: 0.666rem;
    border-radius: 16px;
    background-color: #FFF;
    box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
    list-style: none;
    overflow-y: auto;
}

.chatter-status-wrap .custom-select-box.active .opt-list {
    display: block;
}

.chatter-status-wrap .opt-list .opt-inner {
    padding: 0.866rem 1.333rem;
    border-radius: 10px;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    /* cursor: pointer; */
}

.custom-select-box .opt-item:hover .opt-inner {
    background-color: #E7E7EE;
    color: #2E2E38;
    font-weight: 700;
}

.chatter-status-wrap .chatter-status-header .btn-project-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 0.466rem;
    width: 130px;
    padding: 0.533rem 0.666rem 0.533rem 0.933rem;
    background-color: rgba(0, 0, 0, 0.30);
    border-radius: 50px;
    border: 1px solid #C4C4CD;
    color: #C4C4CD;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
}

.chatter-status-wrap .chatter-status-header .btn-project-list .text {
    white-space: nowrap;
}

.chatter-status-wrap .chatter-status-header .btn-project-list:hover {
    border: 1px solid #FFF;
    color: #FFF;
}

.chatter-status-wrap .chatter-status-header .btn-project-list .icon-arrow {
    display: block;
    width: 14px;
    height: 14px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 5.75L6.99967 9.83333L2.91634 5.75" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.chatter-status-wrap .chatter-status-header .btn-project-list:hover .icon-arrow {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 5.75L6.99967 9.83333L2.91634 5.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.chatter-status-wrap .chatter-status-header .btn-project-list.active .icon-arrow {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 9.25L6.99967 5.16667L2.91634 9.25" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.chatter-status-wrap .chatter-status-header .btn-project-list.active:hover .icon-arrow {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.084 9.25L7.00065 5.16667L2.91732 9.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.chatter-status-wrap .project-box-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.933rem 0;
    margin-top: 4rem;
}

.chatter-status-wrap .project-box-wrap .project-box {
    padding: 2rem;
    background-color: #FFF;
    border-radius: 20px;
}

.chatter-status-wrap .project-box-wrap .project-box .project-title .title {
    font-size: 20px;
    font-weight: 700;
    margin-right: 0.66rem;
}

.chatter-status-wrap .project-box-wrap .project-box .project-title .sub-title {
    font-size: 20px;
    color: #747480;
}

.chatter-status-wrap .project-status-wrap {
    display: grid;
    grid-template-columns: 22.126% 33.805% 43.917%;
    margin-top: 1.06rem;
}

.chatter-status-wrap .project-status-wrap .status-box {
    background-color: transparent;
    border-radius: 0;
    border-right: solid 1px #DDDDE3;
    padding: 0 0.66rem;
}

.chatter-status-wrap .project-status-wrap .status-box:first-child {
    padding-left: 0;
}

.chatter-status-wrap .project-status-wrap .status-box:last-child {
    border: 0;
    padding-right: 0;
}

.chatter-status-wrap .project-status-wrap .status-box .status-title {
    color: #2E2E38;
    font-weight: 700;
    font-size: 14px;
}

@media all and (max-width: 1690px) {
    .chatter-status-wrap .status-box .status-detail {
        padding-left: 8px;
        padding-right: 6px;
    }

    .chatter-status-wrap .status-box .status-detail .status-text {
        font-size: 12px;
    }
}

@media all and (max-width: 1580px) and (min-width: 1150px) {
    .chatter-status-wrap .status-box .status-detail-list {
        grid-template-columns: 2fr 2fr;
    }
    .chatter-status-wrap .status-box .status-detail {
        padding: 0.533rem 0.666rem 0.533rem 0.8rem;
    }

    .chatter-status-wrap .status-box .status-detail .status-text {
        font-size: 14px;
    }
}
/* excel export 팝업 */
.popup-export.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-export .modal-content {
  border-radius: 20px;
}

.popup-export .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-export .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-export#export .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-export label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-export .btn-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  padding: 2.604vw 0 1.562vw;
}

.popup-export .btn-wrap .btn {
  border-color: transparent;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-export .btn-wrap .btn-primary.small {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
}

.popup-export .btn-wrap .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-primary.disabled,
.popup-export .btn-wrap .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-secondary.small {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.popup-export .btn-wrap .btn-secondary:hover {
  background-color: #565662;
}

.popup-export .btn-wrap .btn-secondary.disabled,
.popup-export .btn-wrap .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}
.btn-export {
  width: 100px;
  height: 40px;
  background-color: #168D4C;
  color: #fff;
  border-color: transparent;
}

.btn-export:hover {
  background-color: #006F2E;
  border-color: transparent;
}


.recent-button {
  display: flex;
  align-items: center;
  gap: 0 12px;
  padding: 8px 12px 8px 16px;
  border-radius: 40px;
  border: none;
  background-color: #E7E7EE;
  color:#2E2E38;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.recent-button:hover {
  background-color: #DDDDE3;
}

.recent-button .icon image {
  display: block;
  width: 24px;
  height: 24px;
  /* background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 17H10" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 12H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 7H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 16L13 18L15 20" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5556 14H18.7778C20.0051 14 21 14.8954 21 16C21 17.1046 20.0051 18 18.7778 18H14" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'); */
}

.refresh-button {
  display: flex;
  align-items: center;
  gap: 0 12px;
  padding: 8px 12px 8px 16px;
  border-radius: 40px;
  border: none;
  background-color: #2E2E38;
  color:#FFF;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.refresh-button .icon {
  display: block;
  width: 18px;
  height: 18px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 13.5L4.5 4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 4.5L4.5 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.col{
  gap : 20px;
}
</style>